export const GC_USER_ID = "graphcool-user-id";
export const GC_AUTH_TOKEN = "graphcool-auth-token";
export const VUE_VIEWS = "vue-views";
